module.exports = __webpack_public_path__ + "img/cafe-dulces2.68f66ee7.jpeg";